import { render, staticRenderFns } from "./freehot.vue?vue&type=template&id=38f6daed&scoped=true&"
import script from "./freehot.vue?vue&type=script&lang=js&"
export * from "./freehot.vue?vue&type=script&lang=js&"
import style0 from "./freehot.vue?vue&type=style&index=0&id=38f6daed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6daed",
  null
  
)

export default component.exports